var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4513 9.70219L14.1636 13.4145C14.4565 13.7074 14.4565 14.1823 14.1636 14.4752C13.8707 14.7681 13.3958 14.7681 13.1029 14.4752L9.39062 10.7629L5.67831 14.4752C5.38542 14.7681 4.91055 14.7681 4.61765 14.4752C4.32476 14.1823 4.32476 13.7074 4.61765 13.4145L8.32996 9.70219L4.61765 5.98988C4.32476 5.69699 4.32476 5.22211 4.61765 4.92922C4.91055 4.63633 5.38542 4.63633 5.67831 4.92922L9.39062 8.64153L13.1029 4.92922C13.3958 4.63633 13.8707 4.63633 14.1636 4.92922C14.4565 5.22211 14.4565 5.69699 14.1636 5.98988L10.4513 9.70219Z",
    fill: "#FC5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.bbe47e1b1cf8a29f8f7bdf960d54fbbc.svg";
export { ForwardRef as ReactComponent };